import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import { create } from 'kts-scaffold-framework/utils/form';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import {
    Button,
    Icon,
    Row,
    Form,
    Input,
    Col,
    Modal,
    Upload,
    message,
} from 'antd';

const css = require('./index.scss');
message.config({
    maxCount: 1,
});
/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    componentDidMount() {
        ModulesAction.elegantImagesGet();
    }
    render() {
        return (
            <div className={`${css['company-contariner']}`}>
                <header>
                    <h2>公司风采</h2>
                </header>
                <div className={css.imgList}>
                    <ul>
                        {this.getImgList()}
                        {
                            this.modulesState.imgList.length < 8 && 
                            <li>
                                <Upload
                                    beforeUpload={this.eleganceBeforeUpload}
                                    multiple={true}
                                    showUploadList={false} 
                                    // data={{key, token}}
                                    // headers={{Authorization: user.cToken}}
                                    // action={`//${uploadUrl}`}
                                >
                                    <div className={css.item}>
                                        <div className={css.upload}>
                                            <Icon type="plus" style={{ fontSize: '85px', color: '#ffffff' }} />
                                        </div>
                                    </div>
                                </Upload>
                            </li>
                        }
                    </ul>
                    <div className={css.companyEleganceTip}>
                        公司风采图片将会展示给与您有业务来往以及可能有业务来往的公司，请慎重管理。为了更好展示公司风采，主图的建议尺寸为：长1920像素，宽1080像素。最多支持上传8张图片。
                    </div>
                </div>
                <Modal visible={this.modulesState.showEleganceModal} footer={null} className={css.imgModal} onCancel={() => ModulesAction.showEleganceModal(false)}>
                    <img alt="" style={{ width: '100%' }} src={this.modulesState.imgUrlElegance} />
                </Modal>
            </div>
        );
    }
    // 获取列表图片
    private getImgList = () => {
        if (!Array.isArray(this.modulesState.imgList)) {
            return null;
        }
        return this.modulesState.imgList.map(item => {
            return (
                <li key={item.imageId}>
                    <div className={css.item}>
                        <div className={css.itemHeader} onClick={() => ModulesAction.showEleganceModal(true, item.imgUrl)}>
                            <img className={css.uploadImg} src={item.imgUrl} alt="" />
                            {item.mainImage ? <span className={css.mainImgTip}>主图</span> : null}
                        </div>
                        <div className={css.itemFooter}>
                            <Button disabled={item.mainImage} className={css.setMainImg} onClick={() => { ModulesAction.elegantSetMainImage(item.imageId); }}>设置主图</Button>
                            <Button className={css.deleteImg} onClick={() => { ModulesAction.eleganceImgDelete(item.imageId); }}>删除</Button>
                        </div>
                    </div>
                </li>
            );
        }
        );
    }
    // 上传前
    private eleganceBeforeUpload = (file, fileList) => {
        if (fileList.length + this.modulesState.imgList.length > 8) {
            message.error('最多支持上传8张图片!');
            return false;
        }
        const isJPG = (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/bmp' || file.type === 'image/png');
        if (!isJPG) {
            message.error('请上传jpg、jpeg、bmp、png格式的图片。');
        }
        const isLt2M = file.size / 1024 / 1024 < 5;
        if (!isLt2M) {
            message.error('图片大小不能超过5M!');
        }
        if (isJPG && isLt2M) {
            ModulesAction.eleganceImgUpload(file);
        }
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/CompanyInfo/UI.CompanyElegance.tsx